import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[injectComp]'
})
export class InjectComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
